<template functional>
  <div class="card-footer-item">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "CardFooterItem"
};
</script>
